import loadable from 'react-loadable';

const Home = loadable({
  loader: () => import(/* webpackChunkName: 'Home' */'../../pages/modules/Admin/DashBoard/Home/Home'),
  loading: () => (<></>)
})

const Schools = loadable({
  loader: () => import(/* webpackChunkName: 'Schools' */'../../pages/modules/Admin/Schools'),
  loading: () => (<></>)
})

const Subscriptions = loadable({
  loader: () => import(/* webpackChunkName: 'Subscriptions' */'../../pages/modules/Admin/Subscriptions/Subscriptions'),
  loading: () => (<></>)
})

const Curriculam = loadable({
  loader: () => import(/* webpackChunkName: 'Curriculam' */'../../pages/modules/Admin/Curriculam/Curriculam'),
  loading: () => (<></>)
})

const AddCurriculum = loadable({
  loader: () => import(/* webpackChunkName: 'AddCurriculum' */'../../pages/modules/Admin/Curriculam/NewCurriculam/NewCurriculam'),
  loading: () => (<></>)
})

const ViewCurriculum = loadable({
  loader: () => import(/* webpackChunkName: 'ViewCurriculum' */'../../pages/modules/Admin/Curriculam/ViewCurriculum'),
  loading: () => (<></>)
})

const Account = loadable({
  loader: () => import(/* webpackChunkName: 'Account' */'../../pages/modules/Admin/Account'),
  loading: () => (<></>)
})

// const Storage = loadable({
//   loader: () => import(/* webpackChunkName: 'Admin' */'../../pages/modules/Admin/Storage'),
//   loading: () => (<></>)
// })

const Storage = loadable({
  loader: () => import(/* webpackChunkName: 'Storage' */'../../pages/modules/Admin/Storage'),
  loading: () => (<></>)
})
const CurriculamSettings = loadable({
  loader: () => import(/* webpackChunkName: 'CurriculamSettings' */'../../pages/modules/Admin/CurriculumSettings'),
  loading: () => (<></>)
})
const Staff = loadable({
  loader: () => import(/* webpackChunkName: 'Staff' */'../../pages/modules/Admin/Staff'),
  loading: () => (<></>)
})
const ListCurriculums = loadable({
  loader: () => import(/* webpackChunkName: 'ListCurriculums' */'../../pages/modules/Admin/Curriculam/ListCurriculums'),
  loading: () => (<></>)
})

const AppRoutes = [
  {
    path: "/home",
    Component: Home
  },
  {
    path: "/schools",
    Component: Schools
  },
  {
    path: "/subscriptions",
    Component: Subscriptions
  },
  {
    path: "/curriculum",
    Component: Curriculam
  },
  {
    path: "/curriculum/addcurriculum",
    Component: AddCurriculum
  },
  {
    path: "/curriculum/list",
    Component: ListCurriculums
  },
  {
    path: "/curriculum/view",
    Component: ViewCurriculum
  },
  {
    path: "/account",
    Component: Account
  },
  // {
  //   path: "/storage",
  //   Component: Storage
  // },
  {
    path: "/settings/storage",
    Component: Storage
  },
  {
    path: "/settings/curriculum",
    Component: CurriculamSettings
  },
  {
    path: "/staff",
    Component: Staff
  }
]

export default AppRoutes